import { isIOS, isNativeEnv, isAndroid, iosInteraction, triggerInteraction } from '@lutong/h5-utils';

/**
 * 设置WebView是否透明
 * @param {number} opaque 透明参数, 0: 透明,1: 不透明
 * @return void
 */
export function changeWebviewBgOpacity(opaque = 1) {
	if (isNativeEnv()) {
		if (isAndroid()) {
			// TODO: 暂时没有
		}

		if (isIOS()) {
			iosInteraction('sendMessageToNative', {
				type: 'setWebViewOpaque',
				data: {
					opaque
				}
			});
		}
	}
}

/**
 * 设置WebView是否透明
 * @param {boolean} hidden 是否隐藏webview导航栏
 * @return void
 */
export function setNavigationHidden(hidden = false) {
	if (isNativeEnv()) {
		if (isAndroid()) {
			// TODO: 暂时没有
		}

		if (isIOS()) {
			triggerInteraction({
				type: 'setNavigationHidden',
				data: {
					hidden
				}
			});
		}
	}
}
